import { SET_DRIVERDROPDOWNLIST } from '../actions';

const driverdropdownlist = (state = [], action) => {
  switch (action.type) {
	case SET_DRIVERDROPDOWNLIST:
      return [...action.value];  
    default: return state;
  }
}

export default driverdropdownlist;
